const MessengerIcon = ({ className, ...props }) => {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path 
                d="M13.0654 5.25C15.0592 5.25 16.6259 5.8551 17.7354 6.85938C18.8397 7.85922 19.4359 9.20535 19.583 10.5928C19.8741 13.3381 18.4098 16.3926 15.4062 17.4883C13.1974 18.2939 11.1683 17.7358 10.3359 17.4941L7.58301 19.0107C6.56952 19.5686 5.40749 18.5689 5.80762 17.4834L6.55078 15.4629C5.16775 13.9614 4.87428 11.5227 5.73926 9.45312C6.71329 7.12315 9.12442 5.25004 13.0654 5.25Z" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M10.6473 10.0841L8.47353 13.5622C8.36896 13.7295 8.56958 13.9196 8.73101 13.8061L10.9549 12.2434C11.1929 12.0762 11.508 12.0677 11.7547 12.2218L13.4915 13.3074C13.909 13.5683 14.4585 13.4476 14.7281 13.0357L16.9683 9.61305C17.0781 9.44533 16.8742 9.25005 16.7114 9.36696L14.2933 11.103C14.1015 11.2407 13.8428 11.2387 13.6532 11.098L11.9536 9.83705C11.5295 9.52239 10.9272 9.63632 10.6473 10.0841Z" 
                fill="currentColor" 
                stroke="currentColor" 
                strokeWidth="0.271429" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default MessengerIcon